/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacetValueDto } from './FacetValueDto';
import {
    FacetValueDtoFromJSON,
    FacetValueDtoFromJSONTyped,
    FacetValueDtoToJSON,
    FacetValueDtoToJSONTyped,
} from './FacetValueDto';

/**
 * Une dimension de filtre pilotée par le back. Le panneau de filtres front est générique : il boucle sur les facettes et rend selon type, sans coder en dur aucune dimension. Les valeurs sont déjà triées (count décroissant puis alpha).
 * 
 * @export
 * @interface FacetDto
 */
export interface FacetDto {
    /**
     * Clé de la dimension, mappée vers le champ de filters à renseigner : statuses -> statuses, branches -> branchIds, products -> productIds, tunnels -> tunnelIds, owners -> owners, plateformes -> plateformeIds, brokers -> brokerIds, period -> period.startDate / period.endDate
     * 
     * @type {string}
     * @memberof FacetDto
     */
    key: string;
    /**
     * Libellé affichable du groupe de filtres
     * @type {string}
     * @memberof FacetDto
     */
    label: string;
    /**
     * Type de rendu : "multiselect" (liste d'options cochables) ou "daterange" (période, values vide). Type ouvert pour rester compatible avec de futures dimensions sans changement front.
     * 
     * @type {string}
     * @memberof FacetDto
     */
    type: string;
    /**
     * Options de la dimension (vide pour daterange)
     * @type {Array<FacetValueDto>}
     * @memberof FacetDto
     */
    values: Array<FacetValueDto>;
}

/**
 * Check if a given object implements the FacetDto interface.
 */
export function instanceOfFacetDto(value: object): value is FacetDto {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function FacetDtoFromJSON(json: any): FacetDto {
    return FacetDtoFromJSONTyped(json, false);
}

export function FacetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'type': json['type'],
        'values': ((json['values'] as Array<any>).map(FacetValueDtoFromJSON)),
    };
}

export function FacetDtoToJSON(json: any): FacetDto {
    return FacetDtoToJSONTyped(json, false);
}

export function FacetDtoToJSONTyped(value?: FacetDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'type': value['type'],
        'values': ((value['values'] as Array<any>).map(FacetValueDtoToJSON)),
    };
}

